import { makeStyles } from '@material-ui/core';

import { NAVIGATION_SIDEBAR_PANEL_WIDTH } from 'src/data/common';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: NAVIGATION_SIDEBAR_PANEL_WIDTH,
      flexShrink: 0,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.darkGray,
      padding: theme.spacing(3.5, 2, 3.5),
      overflowY: 'auto',
    },
    logo: {},
    items: {
      flexGrow: 1,
      marginTop: theme.spacing(1.5),
    },
    buttonExtension: {
      marginTop: theme.spacing(1),
    },
    workspaceItem: {
      marginTop: theme.spacing(1),
    },
  }),
  { name: 'NavigationSidebarPanel' }
);
